import { Subscription } from "rxjs"
import { Directive, OnDestroy } from "@angular/core"

@Directive()
export class EduComponent implements OnDestroy {
    subscriptions: Subscription[] = []

    addSub(subscription: Subscription) {
        this.subscriptions.push(subscription)
        return subscription
    }

    clearSubs() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe())
    }

    ngOnDestroy() {
        this.clearSubs()
    }
}
